import axios from 'axios';
import '@/config/axios/axios_config'

export type { AxiosResponse } from 'axios';
export default axios;
